"use client";
import { useState, useEffect } from "react";
import {
  WhatsApp as WhatsAppIcon,
  X as XIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";
export default function ShareButton({
  title,
  url,
}: {
  title: string;
  url?: string;
}) {
  const [hideButton, setHideButton] = useState<boolean>(true);
  let message = "";
  useEffect(() => {
    if (typeof window?.open === "function") {
      if (!url) {
        url = window?.document?.URL;
      }
      message = encodeURIComponent(`${title} ${url}`);
      setHideButton(false);
    }
  });
  function handleWhatAppClick() {
    window.open(`https://wa.me/?text=${message}`, "_blank");
  }
  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?text=${message}`, "_blank");
  };

  const handleLinkedInShare = () => {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        url || "",
      )}`,
      "_blank",
    );
  };
  return (
    <div
      className={`flex flew-row align-middle gap-2 ${hideButton && "hidden"}`}
    >
      <button className="lg:cursor-pointer" onClick={handleWhatAppClick}>
        <WhatsAppIcon />
        <span className="sr-only">Seite per WhatsApp verschicken</span>
      </button>
      <button className="lg:cursor-pointer" onClick={handleTwitterShare}>
        <XIcon />
        <span className="sr-only">Seite per X verschicken</span>
      </button>
      <button className="lg:cursor-pointer" onClick={handleLinkedInShare}>
        <LinkedInIcon />
        <span className="sr-only">Seite per LinkedIn verschicken</span>
      </button>
    </div>
  );
}
